import request from '../../shared/request';
import { PromotionalVideoDisplayResponse } from '../../types/promotionalVideo';

/**
 * Sorteia e retorna um vídeo promocional ativo para exibição na Área do Aluno.
 * Retorna `{ data: null }` quando não há campanha ativa no momento.
 */
export const getPromotionalVideoDisplay = (): Promise<PromotionalVideoDisplayResponse> => {
  return request('/v1/services/promotional-videos/display', {
    method: 'GET',
  });
};
